<template lang="pug">
.container-restricao
    div(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in listaRestricoes'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='habilitarZoomRestricao && (restricoes[index].geometry || restricoes[index].geometria || geometria)'
            )
                div
                    BaseButton(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            slot(name='selecionarRestricao', :restricao='restricoes[index]')
            p
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.car') }}:
                |
                | {{ restricao.codigo_car || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.statusCar') }}:
                |
                | {{ restricao.situacao_car ? getSituacaoCar(restricao.situacao_car) : '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaCar') }}:
                |
                | {{ formatNumber(restricao.area_total_imovel_ha) }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.municipioUf') }}:
                |
                | {{ (restricao.municipio && restricao.uf) ? restricao.municipio + '/' + restricao.uf : '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.elegibilidadeCar') }}:
                |
                | {{ restricao.elegibilidade_car || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.supressaoApos241217') }}:
                |
                | {{ restricao.supressao_apos_241217 || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.supressaoApos271118') }}:
                |
                | {{ restricao.supressao_apos_271118 || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.elegibilidadeSupressao') }}:
                |
                | {{ restricao.elegibilidade_supressao || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaHa') }}:
                |
                | {{ formatNumber(restricao.areaTotalFeatureHa) }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.percentualDeSobreposicao') }}:
                |
                | {{ formatNumberPercent(restricao.percentualSobreposicaoGeometria) }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.tileSentinelAtual') }}:
                |
                | {{ restricao.orbita_ponto_imagem_atual || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.dataImagemSentinelAtual') }}:
                |
                | {{ restricao.data_imagem_atual || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.tileSentinel2018') }}:
                |
                | {{ restricao.orbita_ponto_imagem_2018 || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.dataImagemSentinel2018') }}:
                |
                | {{ restricao.data_imagem_2018 || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.tileSentinel2017') }}:
                |
                | {{ restricao.orbita_ponto_imagem_2017 || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.dataImagemSentinel2017') }}:
                |
                | {{ restricao.data_imagem_2017 || '-' }}
</template>

<script>
import formatters from '@/utils/formatters';
import StatusCar from '@/constants/StatusCar';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'elegibilidade-renovabio',

    data() {
        return {};
    },

    components: {
        BaseButton
    },

    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                if (value.properties) {
                    return {
                        ...value.properties
                    };
                }
                return value;
            });
        }
    },

    methods: {
        aplicarZoomRestricao(index) {
            let geometriaQueNaoEstavaDentroDasRestricoes = null;
            if (this.geometria) {
                geometriaQueNaoEstavaDentroDasRestricoes =
                    this.geometria[index];
            }
            this.$emit(
                'aplicar-zoom-restricao',
                this.restricoes[index],
                geometriaQueNaoEstavaDentroDasRestricoes
            );
        },
        formatNumber(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2);
        },
        formatNumberPercent(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2) + '%';
        },
        getSituacaoCar(codigo) {
            let situacao = StatusCar[codigo];
            
            if (situacao) {
                return situacao;
            }

            return codigo;
        }
    }
};
</script>
